import React, { Component } from 'react';
import { connect } from 'dva';
import { parse } from 'qs';
import { Spin, Table, Input, Button } from 'antd';
import { Toast } from 'antd-mobile';
import DragList from '../../companents/DragList';
import PersonDetails from '../../../List/components/Details';
import styles from './index.less';

const { Search } = Input;

@connect(({ deptMember, loading }) => {
  return {
    loading: loading.effects['deptMember/fetchList'] || false,
    ...deptMember,
  };
})
class DeptMember extends Component {
  constructor(props) {
    super(props);

    const params = parse(window.location.search.split('?').pop());
    this.currentDeptId = params.currentDeptId;

    this.renderHeader = this.renderHeader.bind(this);
    this.renderTableTitle = this.renderTableTitle.bind(this);
    this.handleFetchList = this.handleFetchList.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleDragStateChange = this.handleDragStateChange.bind(this);
    this.handleRomeve = this.handleRomeve.bind(this);
    this.handleSave = this.handleSave.bind(this);
  }

  componentDidMount() {
    this.handleFetchList();
  }

  // 修改个人详情框信息
  handlePersonDetailsChange = userId => {
    const { dispatch } = this.props;

    dispatch({
      type: 'deptMember/fetchUserDetils',
      params: { userId },
    });
  };

  // 获取table数据
  handleFetchList(searchField) {
    const { dispatch } = this.props;

    dispatch({
      type: 'deptMember/fetchList',
      searchParams: { deptId: this.currentDeptId, searchField },
    });
  }

  // 搜索
  handleSearch(val) {
    this.handleFetchList(val);
  }

  // table选中
  handleSave(payload) {
    const { dispatch } = this.props;

    dispatch({
      type: 'deptMember/save',
      payload,
    });
  }

  // 调整顺序状态变化
  handleDragStateChange(isDragPattern) {
    const { dispatch, data } = this.props;
    this.handleSave({ isDragPattern: !isDragPattern });

    if (isDragPattern) {
      dispatch({
        type: 'deptMember/fetchSort',
        params: {
          deptId: this.currentDeptId,
          userIds: (data || []).reduce((userIds, user) => {
            userIds.push(user.userId);
            return userIds;
          }, []),
        },
        callback: this.handleFetchList,
      });
    }
  }

  // 移除用户
  handleRomeve() {
    const { dispatch, selectedRowKeys } = this.props;

    if (!selectedRowKeys || !selectedRowKeys.length) {
      Toast.info('请至少选择一个用户');
      return;
    }

    dispatch({
      type: 'deptMember/removeMember',
      params: { deptId: this.currentDeptId, userIds: selectedRowKeys },
      callback: this.handleFetchList,
    });
  }

  // // 修改页面
  // handleChangePagination(page) {
  //   this.handleSave({
  //     currentPage: page,
  //   });
  // }

  // 渲染选中信息
  renderTableTitle() {
    const { selectedRowKeys } = this.props;

    return (
      <>
        {!!selectedRowKeys.length && (
          <div className="table-selected-info">
            已选 <span>{selectedRowKeys.length}</span> 成员
          </div>
        )}
      </>
    );
  }

  // 渲染头部
  renderHeader() {
    const { isDragPattern } = this.props;
    return (
      <header className="header">
        <div className="btn-list">
          <Button onClick={this.handleRomeve} disabled={isDragPattern}>
            批量移除
          </Button>
          <Button onClick={() => this.handleDragStateChange(isDragPattern)}>
            {isDragPattern ? '关闭调整' : '调整顺序'}
          </Button>
        </div>
        <div className="search-input">
          <Search
            placeholder="请输入姓名、手机号码搜索"
            onSearch={this.handleSearch}
            disabled={isDragPattern}
          />
        </div>
      </header>
    );
  }

  render() {
    const {
      spinProps,
      data,
      columns = [],
      selectedRowKeys,
      tableId,
      isDragPattern,
      currentPage,
      showUserDetailsModal,
      userDetails,
    } = this.props;

    const rowSelection = {
      onChange: pageNumber => this.handleSave({ selectedRowKeys: pageNumber }),
    };
    const tableProps = {
      selectedRowKeys,
      rowSelection,
      columns,

      pagination: {
        pageSizeOptions: ['20', '50', '100', '200'],
        current: currentPage,
        defaultPageSize: 20,
        showSizeChanger: true,
        showQuickJumper: true,
        onChange: page => this.handleSave({ currentPage: page }),
        onShowSizeChange: () => this.handleSave({ currentPage: 1 }),
      },
      title: this.renderTableTitle,
      dataSource: data,
      rowKey: 'userId',
      key: tableId,
      onRow: record => ({
        onClick: () => {
          this.handlePersonDetailsChange(record.userId);
        },
      }),
    };

    if (data.length > 0) {
      tableProps.footer = () => (
        <div className="table-footer">{`共 ${data.length} 条记录 第 ${currentPage} 页`}</div>
      );
    }

    return (
      <div className={styles.root}>
        <Spin {...spinProps}>
          {this.renderHeader()}
          {!isDragPattern && <Table {...tableProps} />}

          {!!isDragPattern && (
            <DragList
              columns={columns}
              data={data}
              currentPage={currentPage}
              handleSort={this.handleSave}
            />
          )}

          {!!showUserDetailsModal && (
            <PersonDetails
              show
              userDetails={userDetails}
              spinning={false}
              isRenderFooter={1}
              handleCancel={this.handlePersonDetailsChange}
            />
          )}
        </Spin>
      </div>
    );
  }
}
export default DeptMember;
